import { groq } from "next-sanity";
import { seoFields } from "../partials/shared";

export const privacyPageQuery = groq`*[_type == "privacyPage"][0] {
  pageTitle,
  _updatedAt,
  content,
}`;

export const privacyPageSeoQuery = groq`
  *[_type == "privacyPage"][0] {
    ${seoFields}
  }
`
